<div class="chat-container">
  <div #messagesContainer class="messages-container">
    @if (showEmptyState()) {
      <app-empty-chat-message class="empty-chat-message"></app-empty-chat-message>
    }
    @for (message of messages(); track message.timestamp + message.author) {
      @switch (message.author) {
        @case ('user') {
          <app-user-message class="user-message" [message]="message"></app-user-message>
        }
        @case ('assistant') {
          <app-copilot-message
            class="copilot-message"
            [message]="message"
            [sendMessage]="chatId()"
            [shouldDisplayRetryButton]="isLatestAssistantMessage(message)"
            (retryRequested)="onRetryRequested($event)"
            (responseSelected)="onResponseSelected($event)"
            (chatNotFound)="onFollowUpChatNotFound()"
          ></app-copilot-message>
        }
      }
    }
    <div #scrollAnchor></div>
  </div>
  <div class="prompt-bar-container">
    <app-copilot-prompt-bar class="prompt-bar" [promptControl]="promptControl"
                            [showModelSelector]="canSelectV2"
                            [selectedModel]="chatModelVersion()"
                            [modelSelectorDisabled]="true"
                            (sendMessage)="onSendMessage($event)"
                            [maxHeight]="312"></app-copilot-prompt-bar>
    @if (myBrand()) {
      <div class="copilot-brand-selection">
        <app-two-stage-brand-picker
          [placeholderText]="'Select brands for tailored answers'"
          [competitorSelectionText]="'Select competitors for comparison'"
          [myBrand]="myBrand()"
          [myCompetitors]="myCompetitors()"
        >
        </app-two-stage-brand-picker>
      </div>
    }
  </div>
</div>
